import React from 'react';

export default class List extends React.Component {

  edit = () => {
    const { editAction } = this.props;
    editAction();
  };

  render() {
    const { children } = this.props;
    return (
      <div className="list-entity">
        <div className="list-entity__actions">
          <button
            onClick={this.edit}
            type="button"
            className="btn btn-primary">
            EDIT
          </button>
        </div>
        <hr/>
        <div className="list-entity__text">
          {children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ListEntity/TextSection.js